import React from "react";
import "./NeonTextEffect.css";

const NeonTextEffect = () => {
    return <h1 className="neon-text">Chongshen Yang</h1>;
};

export default NeonTextEffect;
